import {
  FieldDefaultValue,
  ParticipantsFormDefaultValues,
} from '@/scopes/checkout/domain/types/checkoutPersonalDetails'
import { ParticipantFormFieldIds } from '@/scopes/checkout/domain/types/participantFormFieldIds'
import { ParticipantFormType } from '@/scopes/checkout/domain/types/participantFormType'
import { ParticipantFormStepState } from '@/scopes/checkout/infrastructure/store/participants-form-step-store'

export function isFetchedSelector(state: ParticipantFormStepState) {
  return state.isFetched
}

export function fetchingFailedSelector(state: ParticipantFormStepState) {
  return state.fetchingError
}

export function shouldShowCheckoutErrorSelector(state: ParticipantFormStepState) {
  return state.fetchingError || state.submissionError
}

export function defaultValuesSelector(state: ParticipantFormStepState) {
  return state.participantsByRooms.reduce<ParticipantsFormDefaultValues>((participantsAcc, room) => {
    room.participants.forEach((participant) => {
      participantsAcc[participant.id] = participant.fields.reduce<Partial<Record<string, FieldDefaultValue>>>(
        (fieldsAcc, field) => {
          if (field.id === ParticipantFormFieldIds.Country) {
            fieldsAcc[field.id] = field.defaultValue ?? field.options?.[0].value ?? ''
            return fieldsAcc
          }

          fieldsAcc[field.id] = field.defaultValue ?? ''
          return fieldsAcc
        },
        {},
      )
    })
    return participantsAcc
  }, {})
}

export function availablePhoneCountriesSelector(state: ParticipantFormStepState) {
  return state.availablePhoneCountries
}

export function availablePostalCodeCountriesSelector(state: ParticipantFormStepState) {
  return state.availablePostalCodeCountries
}

export function confirmActionWindowIsOpenSelector(state: ParticipantFormStepState) {
  return state.confirmActionWindowIsOpen
}

export function isSubmittingSelector(state: ParticipantFormStepState) {
  return state.isSubmitting
}

export function getMainBookedCountryFieldNameSelector(state: ParticipantFormStepState) {
  const mainBooker = state.participantsByRooms
    .flatMap(room => room.participants)
    .find(participant => participant.type === ParticipantFormType.MainBooker)

  return (
    mainBooker?.fields.find(field => field.id.includes(ParticipantFormFieldIds.Country))?.name ?? null
  )
}
